import React, { useState } from 'react';
import './AddAartiForm.css';

const AddAartiForm = ({ onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    image_url: '',
    content: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name.trim()) {
      alert('Please enter an aarti name');
      return;
    }

    setLoading(true);
    try {
      await onSave(formData);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="add-aarti-form">
      <div className="form-container">
        <div className="form-header">
          <h1 className="form-title">
            ➕ Add New Aarti
          </h1>
          <button
            onClick={onClose}
            className="back-button"
          >
            ← Back
          </button>
        </div>

        <form onSubmit={handleSubmit} className="aarti-form">
          <div className="form-group">
            <label htmlFor="name" className="form-label">
              Aarti Name <span className="required">*</span>
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="form-input"
              placeholder="Enter aarti name"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="description" className="form-label">
              Description
            </label>
            <input
              type="text"
              id="description"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              className="form-input"
              placeholder="Enter aarti description"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="image_url" className="form-label">
              Image URL
            </label>
            <input
              type="url"
              id="image_url"
              name="image_url"
              value={formData.image_url}
              onChange={handleInputChange}
              className="form-input"
              placeholder="Enter image URL (optional)"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="content" className="form-label">
              Aarti Content
            </label>
            <textarea
              id="content"
              name="content"
              value={formData.content}
              onChange={handleInputChange}
              className="form-textarea"
              placeholder="Enter aarti content (lyrics/text)"
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`submit-button ${loading ? 'loading' : ''}`}
          >
            {loading ? '⏳ Creating Aarti...' : '✅ Create Aarti'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddAartiForm;